import { setAttributes } from "../../js/dom.js";

/**
 * Créé un Element svguicon
 * @param {string} name 
 * @param {object} attributes 
 * @returns {Element}
 */
export const createSvgicon = (name, attributes={}) => {
    const svgUrl = `${VDB_CONFIG.url.theme}/medias/svgicons.svg#${name}`;
    let svg = document.createElement("svg");
    svg = setAttributes(svg, attributes); 
    svg.innerHTML = `<use xlink:href="${svgUrl}"></use>`;
    return svg;
}

/**
 * Créé un svguicon (string)
 * @param {string} name 
 * @param {object} attributes 
 * @returns {string}
 */
export const createSvgiconString = (name, attributes={}) => createSvgicon(name, attributes).outerHTML;